import { render } from "./ArmeniaPage.vue?vue&type=template&id=da1672ee&scoped=true"
import script from "./ArmeniaPage.vue?vue&type=script&lang=js"
export * from "./ArmeniaPage.vue?vue&type=script&lang=js"

import "./ArmeniaPage.vue?vue&type=style&index=0&id=da1672ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1672ee"]])

export default __exports__